// extracted by mini-css-extract-plugin
module.exports = {"card":"V3alX","card__body":"oDeCN","imageContainer":"wk3qL"};